import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import { Props_SnippetValues } from "./Values.props";
import { useState, useEffect, useRef } from "react";

const SnippetValues = (props: Props_SnippetValues) => {
  const { heading, repeatable_valuesprops } = props;
  const containerRef = useRef<HTMLDivElement>(null);

  const [toggleStates, setToggleStates] = useState<boolean[]>(() =>
    repeatable_valuesprops.map(() => false)
  );

  // Keep toggleStates in sync if repeatable_valuesprops changes length
  useEffect(() => {
    setToggleStates((prev) => {
      const newLength = repeatable_valuesprops.length;
      const prevLength = prev.length;

      // If the array got shorter, reset all states to false
      if (newLength < prevLength) {
        return repeatable_valuesprops.map(() => false);
      }

      // If the array got longer, preserve existing states and add false for new items
      return repeatable_valuesprops.map((_, i) => prev[i] || false);
    });
  }, [repeatable_valuesprops.length]);

  const headingClass =
    heading?.visibility?.value === "visible"
      ? ""
      : " snippet-values__heading--hidden";

  return (
    <section className="snippet-values" id={heading?.snippetid?.value || ""}>
      <div className="snippet-values__container" ref={containerRef}>
        <h2 className={"snippet-values__heading " + headingClass}>
          {heading?.content?.value}
        </h2>
        <div className="snippet-values__values-container">
          {repeatable_valuesprops.map((value, index) => (
            <div className="snippet-values__value" key={index}>
              {value.image?.value && (
                <figure className="snippet-values__image-container">
                  <img
                    src={value.image.value}
                    alt={value.imageAlt?.value || "Value Image"}
                    className="snippet-values__image"
                  />
                </figure>
              )}
              <div className="snippet-values__value-content">
                <h3 className="snippet-values__value-heading">
                  {value.value?.value}
                </h3>
                {value.innerText?.value && toggleStates[index] && (
                  <div className="snippet-values__inner-text">
                    {CompileMarkdown(value.innerText.value)}
                  </div>
                )}
                {value.outerText?.value && !toggleStates[index] && (
                  <div className="snippet-values__outer-text">
                    {CompileMarkdown(value.outerText.value)}
                  </div>
                )}
                <button
                  className={
                    toggleStates[index]
                      ? "snippet-values__value-button snippet-values__value-button--active"
                      : "snippet-values__value-button"
                  }
                  aria-pressed={toggleStates[index]}
                  aria-label={
                    toggleStates[index]
                      ? `Hide details for ${value.value?.value ?? "value"}`
                      : `Show details for ${value.value?.value ?? "value"}`
                  }
                  onClick={() =>
                    setToggleStates((prev) =>
                      prev.map((state, i) => (i === index ? !state : state))
                    )
                  }
                >
                  <span className="accessible-heading">
                    {toggleStates[index] ? "Hide details" : "Show details"}
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SnippetValues;